import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addChallenges } from "../../features/slices/challanges";
import {
  getCategoryDropDown,
  imageUpload,
} from "../../features/slices/liveStream";
import upploadImage from "../../assets/images/upload-video.png";
import { toastService } from "../../utils/toastify";
import { useNavigate } from "react-router-dom";
import LoaderForImage from "../LoaderForImage";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "ckeditor5/ckeditor5.css";
import {
  ListProperties,
  Alignment,
  List,
  Image,
  AutoImage,
  ImageInsert,
  ImageResize, // Add this
  ImageToolbar, // Add this
  ImageStyle, // Add this
  ImageCaption,
  SimpleUploadAdapter,
  Base64UploadAdapter,
} from "ckeditor5";

import {
  ClassicEditor,
  Bold,
  Essentials,
  Italic,
  Mention,
  Paragraph,
  Undo,
} from "ckeditor5";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import QuillEditor from "../QuillEditor";
import VideoPlayer from "../VideoPlayer";
const initialState = {
  categoryId: "",
  title: "",
  startDate: "",
  endDate: "",
  noOfPrizes: "",
  prizeDetails: "",
  participationRules: "",
  Video: "",
  submissionGuidelines: "",
  image: "",
  description: "",
};

const AddChallenges = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [imageLoader, setImageLoader] = useState({
    video: false,
    image: false,
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { categoryDropDownData, loading } = useSelector(
    (state) => state.liveStream
  );

  const {
    categoryId,
    title,
    startDate,
    endDate,
    noOfPrizes,
    prizeDetails,
    participationRules,
    Video,
    submissionGuidelines,
    image,
    description,
  } = iState;

  useEffect(() => {
    dispatch(getCategoryDropDown());
  }, [dispatch]);

  const handleChanges = (e) => {
    const { name, value } = e.target;
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!title?.trim()) {
      formErrors.title = "Title is required.";
      isValid = false;
    }

    if (!categoryId?.trim()) {
      formErrors.categoryId = "Category is required.";
      isValid = false;
    }

    if (!startDate?.trim()) {
      formErrors.startDate = "Start date is required.";
      isValid = false;
    }

    if (!endDate?.trim()) {
      formErrors.endDate = "End date is required.";
      isValid = false;
    }

    if (!noOfPrizes) {
      formErrors.noOfPrizes = "Number of prizes is required.";
      isValid = false;
    }

    if (!prizeDetails?.trim()) {
      formErrors.prizeDetails = "Prize details are required.";
      isValid = false;
    }

    if (!participationRules?.trim()) {
      formErrors.participationRules = "Description are required.";
      isValid = false;
    }

    if (!submissionGuidelines?.trim()) {
      formErrors.submissionGuidelines = "Submission guidelines are required.";
      isValid = false;
    }

    if (!Video?.trim()) {
      formErrors.Video = "Video is required.";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleVideo = (e) => {
    const file = e.target.files[0];
    setErrors((prev) => ({ ...prev, Video: "" }));
    setImageLoader((prev) => ({
      ...prev,
      video: true,
    }));

    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);

      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Video uploaded successfully");
          setUpdateState((prev) => ({ ...prev, Video: res?.payload?.url }));
        } else {
          toastService.error("Failed to upload video");
        }
        setImageLoader((prev) => ({
          ...prev,
          video: false,
        }));
      });
    }
  };
  const handleQuillChange = (name, value) => {
    setErrors((prev) => ({ ...prev, [name]: "" })); // Reset error for the specific field
    setUpdateState((prev) => ({ ...prev, [name]: value })); // Dynamically update the corresponding state field
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      dispatch(addChallenges(iState)).then((res) => {
        if (res?.payload?.code == 200) {
          toastService.success("Challenge added successfully");
          setUpdateState(iState);
          navigate("/challenges");
        }
        // else {
        //   toastService.error("Failed to add challenge");
        // }
      });
    }
  };
  const handleImage = (e) => {
    setErrors((prev) => ({
      ...prev,
      [e?.target?.name]: "",
    }));
    const file = e.target.files[0];
    setImageLoader((prev) => ({
      ...prev,
      image: true,
    }));
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);

      dispatch(imageUpload(formData)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Image uploaded successfully");
          setUpdateState({
            ...iState,
            [e.target.name]: res?.payload?.url,
          });
          setImageLoader((prev) => ({
            ...prev,
            image: false,
          }));
        } else {
          toastService.error("Failed to upload");
          setImageLoader((prev) => ({
            ...prev,
            image: false,
          }));
        }
      });
    }
  };

  const handleChangeEditor = (name, value) => {
    setErrors((prev) => ({ ...prev, [name]: "" }));
    setUpdateState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleChangeEmbeddedVideo = (e) => {
    setErrors((prev) => ({
      ...prev,
      Video: "",
    }));
    setUpdateState((prev) => ({
      ...prev,
      Video: e?.target?.value,
    }));
  };
  const today = new Date().toISOString().split("T")[0];
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Add New Challenge</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Title of Challenge</label>
              <input
                type="text"
                name="title"
                className="form-control"
                placeholder="Enter Title of Challenge"
                value={title}
                onChange={handleChanges}
              />
              {errors.title && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.title}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Category</label>
              <select
                className="form-control"
                name="categoryId"
                value={categoryId}
                onChange={handleChanges}
              >
                <option value="">Select</option>
                {categoryDropDownData?.result?.map((res) => (
                  <option key={res?._id} value={res?._id}>
                    {res?.categoryName}
                  </option>
                ))}
              </select>
              {errors.categoryId && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.categoryId}
                </p>
              )}
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Start Date</label>
                  <input
                    type="date"
                    name="startDate"
                    className="form-control"
                    value={startDate}
                    max={endDate}
                    onChange={handleChanges}
                    min={today}
                  />
                  {errors.startDate && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.startDate}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Deadline Date</label>
                  <input
                    type="date"
                    name="endDate"
                    className="form-control"
                    value={endDate}
                    min={startDate}
                    onChange={handleChanges}
                  />
                  {errors.endDate && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.endDate}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>No. of Prizes</label>
              <input
                type="number"
                name="noOfPrizes"
                className="form-control"
                placeholder="Enter no. of prizes"
                min={0}
                value={noOfPrizes}
                onChange={handleChanges}
              />
              {errors.noOfPrizes && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.noOfPrizes}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Prize Details</label>
              {/* <input
                type="text"
                name="prizeDetails"
                className="form-control"
                placeholder="Enter Prize Details"
                value={prizeDetails}
                onChange={handleChanges}
              /> */}
              <QuillEditor
                name="prizeDetails"
                value={prizeDetails}
                onChange={handleQuillChange}
                error={errors.prizeDetails}
                // Optional custom height
              />

              {/* <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "|",
                    "paragraph",
                    "heading1",
                    "heading2",
                    "|",
                    "bulletedList",
                    // "numberedList",
                    "alignment",
                    // "toggleImageCaption",
                    // "imageTextAlternative",
                    // "ckboxImageEdit",
                    // "insertImage",
                    // "imageResize",
                  ],
                  list: {
                    properties: {
                      styles: true,
                      startIndex: true,
                      reversed: true,
                    },
                  },
                  plugins: [
                    List,
                    ListProperties,
                    Bold,
                    Essentials,
                    Italic,
                    Mention,
                    Paragraph,
                    Undo,
                    Alignment,
                    // Image,
                    // AutoImage,
                    // ImageInsert,
                    // ImageResize, // Add this
                    // ImageToolbar, // Add this
                    // ImageStyle, // Add this
                    // ImageCaption,
                    // SimpleUploadAdapter,
                    // Base64UploadAdapter, // Add this
                  ],
                  // image: {
                  //   toolbar: [
                  //     "imageTextAlternative",
                  //     "toggleImageCaption",
                  //     "imageStyle:inline",
                  //     "imageStyle:block",
                  //     "imageStyle:side",
                  //   ],
                  // },
                  // simpleUpload: {
                  //   uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                  // },
                  mention: {
                    // Mention configuration
                  },
                }}
                name="prizeDetails"
                data={prizeDetails}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  handleChangeEditor("prizeDetails", data);
                }}
              /> */}
            </div>

            <div className="form-group">
              <label>Submission Guidelines</label>
              <input
                type="text"
                name="submissionGuidelines"
                className="form-control"
                placeholder="Enter Submission Guidelines"
                value={submissionGuidelines}
                onChange={handleChanges}
              />
              {errors.submissionGuidelines && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.submissionGuidelines}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Description</label>
              <QuillEditor
                name="participationRules"
                value={participationRules}
                onChange={handleQuillChange}
                error={errors.participationRules}
                // Optional custom height
              />
              {/* <CKEditor
                editor={ClassicEditor}
                config={{
                  toolbar: [
                    "undo",
                    "redo",
                    "|",
                    "bold",
                    "italic",
                    "|",
                    "paragraph",
                    "heading1",
                    "heading2",
                    "|",
                    "bulletedList",
                    // "numberedList",
                    "alignment",
                    // "toggleImageCaption",
                    // "imageTextAlternative",
                    // "ckboxImageEdit",
                    // "insertImage",
                    // "imageResize",
                  ],
                  list: {
                    properties: {
                      styles: true,
                      startIndex: true,
                      reversed: true,
                    },
                  },
                  plugins: [
                    List,
                    ListProperties,
                    Bold,
                    Essentials,
                    Italic,
                    Mention,
                    Paragraph,
                    Undo,
                    Alignment,
                    // Image,
                    // AutoImage,
                    // ImageInsert,
                    // ImageResize, // Add this
                    // ImageToolbar, // Add this
                    // ImageStyle, // Add this
                    // ImageCaption,
                    // SimpleUploadAdapter,
                    // Base64UploadAdapter, // Add this
                  ],
                  // image: {
                  //   toolbar: [
                  //     "imageTextAlternative",
                  //     "toggleImageCaption",
                  //     "imageStyle:inline",
                  //     "imageStyle:block",
                  //     "imageStyle:side",
                  //   ],
                  // },
                  // simpleUpload: {
                  //   uploadUrl: "your-server-url-to-handle-image-upload", // Add your upload API here
                  // },
                  mention: {
                    // Mention configuration
                  },
                }}
                name="participationRules"
                data={participationRules}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  handleChangeEditor("participationRules", data);
                }}
              /> */}

              {errors.participationRules && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.participationRules}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Embedded Video</label>
              <input
                type="text"
                className="form-control"
                placeholder="Embedded Video Url"
                onChange={handleChangeEmbeddedVideo}
                name="Video"
                value={Video}
              />
              {/* {errors.courseMedia.video && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.courseMedia.video}
                </p>
              )} */}
            </div>
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Upload Video</h4>
          </div>
          <div className="CommonForm">
            {imageLoader.video ? (
              <LoaderForImage />
            ) : (
              <div>
                <div
                  className="UploadBox Image"
                  style={{ position: "relative", zIndex: 0 }}
                >
                  {!imageLoader ? (
                    <LoaderForImage />
                  ) : (
                    <span>
                      {!Video && <img src={upploadImage} alt="Upload" />}{" "}
                      {/* Default upload image */}
                      {Video && (
                        <>
                          {/* <video
                            src={Video} // Create a URL for the uploaded video file
                            controls
                            controlsList="nodownload"
                            style={{
                              position: "absolute",
                              top: "0",
                              left: "0",
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              zIndex: 1, // Make sure the video is above the input
                            }}
                          /> */}
                          <VideoPlayer
                            url={Video}
                            divHeight="110px"
                            divStyle={{
                              height: "100%",
                              position: "absolute",
                              top: "0",
                              left: "0",
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              zIndex: 1,
                            }}
                          />

                          {/* Edit icon to update the video */}
                          <i
                            className="fas fa-edit"
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                              color: "#fff",
                              background: "rgba(0, 0, 0, 0.6)",
                              borderRadius: "50%",
                              padding: "5px",
                              zIndex: 2, // Place icon above the video
                              cursor: "pointer",
                            }}
                            onClick={() =>
                              document.querySelector(`#file-input`).click()
                            } // Trigger file input on icon click
                          />
                        </>
                      )}
                    </span>
                  )}
                  {/* File input field */}
                  <input
                    id="file-input"
                    type="file"
                    name="video"
                    accept=".mp4"
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      zIndex: Video ? 0 : 2,
                      cursor: "pointer",
                    }}
                    onChange={(e) => handleVideo(e)}
                  />
                  {/* Text to prompt upload if no video is uploaded */}
                  {!Video && (
                    <p>
                      <label>Click to upload video</label> or <br /> drag &amp;
                      drop
                    </p>
                  )}
                </div>
                {errors.Video && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.Video}
                  </p>
                )}
              </div>
            )}
          </div>

          <div className="TitleBox Border">
            <h4 className="Title">Upload Image</h4>
          </div>
          <div className="CommonForm">
            {imageLoader.image ? (
              <LoaderForImage />
            ) : (
              <div>
                <div
                  className="UploadBox Image"
                  style={{
                    position: "relative",
                    zIndex: 0,
                  }}
                >
                  <span style={{ zIndex: "999" }}>
                    {!image && <img src={upploadImage} alt="Upload" />}
                    {image && (
                      <>
                        <img
                          src={image}
                          alt="Uploaded"
                          style={{
                            position: "absolute",
                            top: "0",
                            left: "0",
                            width: "100%",
                            height: "100%",
                            objectFit: "contain",
                            mixBlendMode: "darken",
                          }}
                        />
                        <i
                          className="fas fa-edit"
                          style={{
                            position: "absolute",
                            top: "5px",
                            right: "5px",
                            color: "#fff",
                            background: "rgba(0, 0, 0, 0.6)",
                            borderRadius: "50%",
                            padding: "5px",
                            zIndex: 2, // Place icon above the image
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            document.querySelector(`#file-image-input`).click()
                          } // Trigger file input on icon click
                        />
                      </>
                    )}
                  </span>
                  {/* File input field */}
                  <input
                    id="file-image-input"
                    type="file"
                    accept=".png,.jpg,.jpeg"
                    name="image"
                    style={{
                      position: "absolute",
                      top: "0",
                      left: "0",
                      width: "100%",
                      height: "100%",
                      opacity: 0,
                      cursor: "pointer",
                    }}
                    onChange={(e) => handleImage(e)}
                  />
                  {/* Text to prompt upload if no image is uploaded */}
                  {!image && (
                    <p>
                      <label>Upload Image</label> <br /> or drag &amp; drop
                    </p>
                  )}
                </div>
                {errors.image && (
                  <p className="d-flex justify-content-start text-danger mt-2 ">
                    {errors.image}
                  </p>
                )}
              </div>
            )}
          </div>

          <button className="Button" onClick={handleSubmit}>
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddChallenges;
